'use client';

import { HubNewsItem } from '@/types/hubs';
import { NoData } from '@/components/NoData';
import HubNewsListUnit from '@/(routers)/hubs/cases/components/unit/HubNewsListUnit';

const GRID_CLASS = {
    page: 'grid gap-4 w-full grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4',
    slide: 'grid gap-4 w-full grid-cols-1 sm:grid-cols-2',
};

export interface HubNewsListProps {
    hubNewsList: HubNewsItem[];
    hubNewsCounts?: Record<string, number>;
    onSelectHub?: (hubIndex: string) => void;
    columns?: keyof typeof GRID_CLASS;
    bordered?: boolean;
}

export default function HubNewsList({
    hubNewsList,
    hubNewsCounts,
    onSelectHub,
    columns = 'page',
    bordered = false,
}: HubNewsListProps) {
    return (
        <>
            {hubNewsList && hubNewsList.length > 0 ? (
                <div className={GRID_CLASS[columns]}>
                    {hubNewsList.map((hubNews) => (
                        <div className="flex w-full" key={hubNews.hub_news_index}>
                            <HubNewsListUnit
                                hubNews={hubNews}
                                hubNewsCount={hubNewsCounts?.[hubNews.hub_index]}
                                onSelectHub={onSelectHub}
                                bordered={bordered}
                            />
                        </div>
                    ))}
                </div>
            ) : (
                <NoData message="事例が見つかりませんでした。" />
            )}
        </>
    );
}
